"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputUnmemoized = TextInput;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/styles");
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _Copy = _interopRequireDefault(require("../Copy/Copy"));
var _ref = require("../../utils/ref");
var _TextInputContext = require("./TextInputContext");
var _excluded = ["children", "className", "disabled", "displayErrors", "embedded", "hasError", "hasRequired", "hasSuccess", "hasValidation", "inputClassName", "inputRef", "name", "readOnly", "required", "setDisplayErrorsState", "setLoadingState", "title"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import type { ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: {
      position: 'relative'
    },
    input: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.truncate), {}, {
      '&:required:invalid': {
        paddingRight: theme.variables.inputRequiredPaddingRight
      },
      '&:focus:required:invalid, &:required:valid': _objectSpread(_objectSpread({}, theme.mixins.inputPadding), {}, {
        '& ~ $required': {
          display: 'none'
        }
      })
    }),
    hasChildren: {
      paddingRight: theme.variables.inputRequiredPaddingRight,
      '&:required:invalid': {
        paddingRight: theme.variables.inputRequiredPaddingRight
      },
      '&:focus:required:invalid, &:required:valid': {
        paddingRight: theme.variables.inputRequiredPaddingRight
      }
    },
    displayErrors: {
      '&:valid': theme.mixins.inputSuccess,
      '&:invalid': theme.mixins.inputError
    },
    success: theme.mixins.inputSuccess,
    error: theme.mixins.inputError,
    required: {},
    embedded: {
      '& input': {
        border: "1px solid ".concat(theme.colors.lightGrey),
        borderRadius: theme.variables.borderRadiusSmall,
        backgroundColor: theme.colors.ghostWhite,
        margin: 0,
        '&:hover, &:focus, &:focus-within': {
          backgroundColor: theme.colors.ghostWhite,
          border: "1px solid ".concat(theme.colors.lightGrey)
        }
      }
    },
    embeddedInput: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      height: '2rem',
      paddingTop: '0.25rem',
      paddingBottom: '0.25rem',
      lineHeight: '1.43rem'
    })
  };
});

// Here $Diff prevents creating impossible `children` type
// https://flow.org/en/docs/types/intersections/#toc-impossible-intersection-types
/*:: export type TextInputType = $Diff<
  HTMLInputElement,
  {
    children: React.Element<typeof Copy>
  }
> & {
  children?: React.Element<typeof Copy>,
  displayErrors?: boolean,
  embedded?: boolean,
  hasError?: boolean,
  hasRequired?: boolean,
  hasSuccess?: boolean,
  hasValidation?: boolean,
  inputClassName?: string,
  inputRef?: React.Ref<'input'>,
  setDisplayErrorsState?: (displayErrors: boolean) => mixed,
  setLoadingState?: (loading: boolean) => mixed
};*/
function TextInput(props /*: TextInputType*/) {
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    displayErrors = props.displayErrors,
    embedded = props.embedded,
    hasError = props.hasError,
    hasRequired = props.hasRequired,
    hasSuccess = props.hasSuccess,
    hasValidation = props.hasValidation,
    inputClassName = props.inputClassName,
    inputRefProp = props.inputRef,
    name = props.name,
    readOnly = props.readOnly,
    required = props.required,
    setDisplayErrorsState = props.setDisplayErrorsState,
    setLoadingState = props.setLoadingState,
    title = props.title,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = useStyles();
  var ownRef = React.useRef(null);
  var ref = (0, _ref.useForkedRef)(inputRefProp, ownRef);
  var hasChildren = children !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.embedded, embedded), className),
    title: title
  }, /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.input, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.displayErrors, displayErrors), classes.embeddedInput, embedded), classes.error, hasError), classes.hasChildren, hasChildren), classes.success, hasSuccess), inputClassName),
    "data-name": name,
    "data-testid": name || 'text-input',
    disabled: disabled,
    ref: ref,
    name: name,
    readOnly: readOnly,
    required: required
  }, other)), !hasChildren && /*#__PURE__*/React.createElement(_InputRequired.default, {
    className: classes.required,
    disabled: disabled,
    embedded: embedded,
    hasRequired: hasRequired,
    readOnly: readOnly,
    required: required
  }), hasChildren && /*#__PURE__*/React.createElement(_TextInputContext.TextInputProvider, {
    value: {
      inputRef: ownRef
    }
  }, children));
}
TextInput.displayName = 'TextInput';
TextInput.defaultProps = {
  autoComplete: 'off',
  disabled: false,
  displayErrors: false,
  embedded: false,
  hasError: false,
  hasRequired: true,
  hasSuccess: false,
  readOnly: false,
  required: false,
  type: 'text'
};

// Export unmemoized version for cosmos fixtures (react-cosmos can't handle memo components)
var _default = exports.default = React.memo(TextInput);
//# sourceMappingURL=TextInput.js.map